/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateEmployeePostClassStudentRequestViewModel } from "../types/CreateEmployeePostClassStudentRequestViewModel.ts";

export const createEmployeePostClassStudentRequestViewModelSchema = z.object({
  classStudentId: z.optional(z.number().int()),
}) as unknown as ToZod<CreateEmployeePostClassStudentRequestViewModel>;
